import React from 'react';
import { Box, Typography, Link, Stack } from '@mui/material';
import { Link as RouterLink } from "react-router-dom";

const Footer = () => {
  return (
    <>
    
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        maxHeight: '30px', // Set a fixed height for the footer
        // minHeight:'30px',
        backgroundColor: '#1976d2',
        color: 'white',
        // py: 0,
        textAlign: 'center',
        
      }}
    >
      <Stack direction="row" spacing={2} 
         justifyContent="center"
         alignItems="center"
         p={1}
      >
        <Box>
      <Typography variant="body1" fontSize={10}>
        &copy; Copyright (c) 2024-25 - 
        <a rel="noopener noreferrer" href="https://www.omnevu.com" 
          target="_blank" style={{color:'white'}}>Omnevu.com</a>
    
    </Typography>
    
      </Box>

      <Box 
        sx={{mt: '1'}}>
      <Typography variant="body1" fontSize={10}>
      <Link
        href="/terms-and-conditions"
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: 'white', textDecoration: 'underline',   display: 'block' }}
      >
        Terms & Conditions and Privacy Policy
      </Link>
      </Typography>
      </Box>
      
      </Stack>
      
    </Box>
    </>
  );
};

export default Footer;